import { AuthorizationAPI } from './AuthorizationAPI/AuthorizationAPI';
import { ServiceAPI } from '@shared/api/ServiceAPI/ServiceAPI';

export class ClearingAPI {
    static get authorization() {
        return AuthorizationAPI.getMethods();
    }

    static get settings() {
        return ServiceAPI.getMethods();
    }
}
